import React, { useState, useEffect } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Checkbox from "../../../components/Checkbox";
import Loader from "../../../components/Loader";
import Row from "./Row";

const Table = ({ 
  sessionGroups = [], 
  loading, 
  error, 
  noResults, 
  selectedIds = [], 
  onSelectionChange, 
  onDeleteSessionGroup, 
  onDuplicateSessionGroup 
}) => {
  const [chooseAll, setChooseAll] = useState(false);

  // Mettre à jour l'état "Tout sélectionner" en fonction des sélections
  useEffect(() => {
    if (sessionGroups.length > 0) {
      setChooseAll(sessionGroups.every(sessionGroup => selectedIds.includes(sessionGroup.id)));
    } else {
      setChooseAll(false);
    }
  }, [sessionGroups, selectedIds]);

  const handleChooseAll = () => {
    const newChooseAll = !chooseAll;
    console.log('handleChooseAll called:', { newChooseAll, sessionGroupsCount: sessionGroups.length });
    
    if (newChooseAll) {
      // Sélectionner tous les groupes de sessions
      sessionGroups.forEach(sessionGroup => {
        console.log('Selecting sessionGroup:', sessionGroup.id);
        onSelectionChange(sessionGroup.id, true);
      });
    } else {
      // Désélectionner tous les groupes de sessions
      sessionGroups.forEach(sessionGroup => {
        console.log('Deselecting sessionGroup:', sessionGroup.id);
        onSelectionChange(sessionGroup.id, false);
      });
    }
  };

  const handleRowSelectionChange = (sessionGroupId) => {
    const isSelected = selectedIds.includes(sessionGroupId);
    onSelectionChange(sessionGroupId, !isSelected);
  };

  if (loading) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.loading}>
          <Loader />
          <span>Chargement des groupes de sessions...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.error}>{error}</div>
      </div>
    );
  }

  if (noResults || sessionGroups.length === 0) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.empty}>
          <p>Aucun groupe de session trouvé.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.table}>
        <div className={styles.row}>
          <div className={styles.col}>
            <Checkbox
              className={styles.checkbox}
              checked={chooseAll}
              onChange={handleChooseAll}
            />
          </div>
          <div className={styles.col}>Groupe</div>
          <div className={styles.col}>Nombre d'élèves</div>
          <div className={styles.col}>Date de création</div>
          <div className={styles.col}></div>
        </div>
        {sessionGroups.map((sessionGroup, index) => (
          <Row
            item={sessionGroup}
            key={sessionGroup.id}
            index={index}
            value={selectedIds.includes(sessionGroup.id)}
            onChange={() => handleRowSelectionChange(sessionGroup.id)}
            onDelete={onDeleteSessionGroup}
            onDuplicate={onDuplicateSessionGroup}
          />
        ))}
      </div>
    </div>
  );
};

export default Table;
